/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Wiz_Tip_Reglink_TInputs */



/**
* | output |
* | --- |
* | "Link the ticket page" |
*
* @param {Tournament_Wiz_Tip_Reglink_TInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_wiz_tip_reglink_t = /** @type {((inputs?: Tournament_Wiz_Tip_Reglink_TInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Wiz_Tip_Reglink_TInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Liez la billetterie")
	if (locale === "es") return /** @type {LocalizedString} */ ("Enlace la página de entradas")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Vincule a página de ingressos")
	if (locale === "it") return /** @type {LocalizedString} */ ("Collega la pagina delle iscrizioni")
	return /** @type {LocalizedString} */ ("Link the ticket page")
});